/* DracoSlides size-select guard
   Prevents accidental purchases of the default preselected size.
   On product pages with a Size option: deselects the size on load,
   greys out ATC until a size is chosen, and blocks any add-to-cart
   path (main button, sticky bar, dynamic checkout) without a size.
   Deep links with ?variant= are respected and skip the guard. */
(function () {
  'use strict';

  if (new URLSearchParams(window.location.search).has('variant')) return;

  var state = { active: false, form: null, radios: [], btn: null, labelEl: null, originalLabel: '', msgEl: null, pillsWrap: null };

  function injectCss() {
    var css = [
      '.size-guard-inactive { opacity: .55; }',
      '.size-guard-hidden-pay .shopify-payment-button { display: none !important; }',
      '.size-guard-msg { display: none; color: #eb001b; font-weight: 600; margin-top: 6px; font-size: 1.4rem; }',
      '.size-guard-msg.visible { display: block; }',
      '@keyframes sizeGuardShake { 0%,100%{transform:translateX(0)} 20%,60%{transform:translateX(-5px)} 40%,80%{transform:translateX(5px)} }',
      '.size-guard-shake { animation: sizeGuardShake .4s ease; }'
    ].join('\n');
    var tag = document.createElement('style');
    tag.textContent = css;
    document.head.appendChild(tag);
  }

  function findParts() {
    var productForm = document.querySelector('product-form[data-main="true"]') || document.querySelector('product-form.main-product-form');
    if (!productForm) return false;
    var sectionId = productForm.dataset.section;
    var picker = document.getElementById('variant-selects-' + sectionId);
    if (!picker) return false;

    var radios = Array.prototype.filter.call(picker.querySelectorAll('input[type="radio"]'), function (r) {
      if (r.dataset.swatch) return false;
      if (r.closest('.quantity-breaks-container') || r.closest('.quantity-break')) return false;
      return /size/i.test(r.name || '');
    });
    if (!radios.length) return false;

    var form = document.getElementById(radios[0].getAttribute('form')) || productForm.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return false;

    state.form = form;
    state.radios = radios;
    state.btn = document.getElementById('ProductSubmitButton-' + sectionId) || form.querySelector('button[name="add"]');
    state.labelEl = state.btn ? state.btn.querySelector('.main-atc__label__text') : null;
    state.pillsWrap = radios[0].closest('.product-form__input') || radios[0].parentElement;
    return true;
  }

  function activate() {
    state.radios.forEach(function (r) { r.checked = false; });
    state.active = true;
    if (state.btn) {
      state.btn.classList.add('size-guard-inactive');
      if (state.btn.dataset.unavailable !== 'true' && state.labelEl) {
        state.originalLabel = state.labelEl.textContent;
        state.labelEl.textContent = 'SELECT YOUR SIZE';
      }
    }
    if (state.form) state.form.classList.add('size-guard-hidden-pay');
    if (state.pillsWrap && !state.msgEl) {
      state.msgEl = document.createElement('div');
      state.msgEl.className = 'size-guard-msg';
      state.msgEl.textContent = 'Please select your size';
      state.pillsWrap.appendChild(state.msgEl);
    }
  }

  function release() {
    if (!state.active) return;
    state.active = false;
    if (state.btn) {
      state.btn.classList.remove('size-guard-inactive');
      if (state.labelEl && state.originalLabel) state.labelEl.textContent = state.originalLabel;
    }
    if (state.form) state.form.classList.remove('size-guard-hidden-pay');
    if (state.msgEl) state.msgEl.classList.remove('visible');
  }

  function nudge() {
    if (state.msgEl) state.msgEl.classList.add('visible');
    if (state.pillsWrap) {
      state.pillsWrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
      state.pillsWrap.classList.remove('size-guard-shake');
      void state.pillsWrap.offsetWidth;
      state.pillsWrap.classList.add('size-guard-shake');
    }
  }

  function sizeChosen() {
    return !state.borrowed && state.radios.some(function (r) { return r.checked; });
  }

  function guardEvent(e) {
    if (!state.active) return;
    if (sizeChosen()) { release(); return; }
    e.preventDefault();
    e.stopImmediatePropagation();
    nudge();
  }

  function init() {
    if (!findParts()) return;
    injectCss();
    activate();

    state.radios.forEach(function (r) {
      r.addEventListener('change', function () { state.borrowed = false; if (sizeChosen()) release(); });
    });

    state.form.addEventListener('submit', guardEvent, true);

    function returnBorrowed() {
      if (!state.borrowed) return;
      state.borrowed = false;
      if (state.active) state.radios.forEach(function (r) { r.checked = false; });
    }

    var picker = state.pillsWrap && state.pillsWrap.closest('[id^="variant-selects-"]');
    if (picker) {
      picker.addEventListener('change', function (e) {
        var t = e.target;
        if (!state.active || t.type !== 'radio' || state.radios.indexOf(t) > -1 || sizeChosen()) return;
        state.radios[0].checked = true;
        state.borrowed = true;
        setTimeout(returnBorrowed, 2000);
      }, true);
    }

    if (state.labelEl && window.MutationObserver) {
      new MutationObserver(function () {
        returnBorrowed();
        if (state.active && !state.btn.disabled && state.btn.dataset.unavailable !== 'true' && state.labelEl.textContent !== 'SELECT YOUR SIZE') {
          state.labelEl.textContent = 'SELECT YOUR SIZE';
          state.btn.classList.add('size-guard-inactive');
        }
      }).observe(state.labelEl, { childList: true, characterData: true, subtree: true });
    }

    document.addEventListener('click', function (e) {
      if (!state.active) return;
      var t = e.target;
      if (!(t instanceof Element)) return;
      var hit = t.closest('button[name="add"], [id^="SectionAtcBtn-"], .shopify-payment-button, .sticky-atc button, .sticky-atc .button');
      if (!hit) return;
      var withinMain = hit.closest('product-form[data-main="true"], .main-product-form, .sticky-atc');
      if (!withinMain) return;
      guardEvent(e);
    }, true);
  }

  if (document.readyState === 'complete') {
    setTimeout(init, 150);
  } else {
    window.addEventListener('load', function () { setTimeout(init, 150); });
  }
})();
